import * as React from "react";
import { LiveTableHeaderColumn } from "../LiveTableHeaderColumn";
import { AutoTimer } from "../../../../AutoTimer";
export const LiveTableHeader = (props) => {
    return (React.createElement("thead", { className: "rj-scoreboard__live-table-head", "data-uat": "scoreboard-live-table-head" },
        React.createElement("tr", { className: "rj-scoreboard__live-table-head-row" },
            React.createElement("th", { className: "rj-scoreboard__live-table-head-title-time" },
                React.createElement("span", { className: "rj-scoreboard__live-table-head-title" }, props.title),
                props.liveGameState.gameTime &&
                    React.createElement(AutoTimer, { gameTime: props.liveGameState.gameTime, clockDirection: props.liveGameState.clockDirection, clockRunning: props.liveGameState.clockRunning, includeSeconds: true })),
            props.header.map((value, index) => React.createElement(LiveTableHeaderColumn, Object.assign({}, { value, index }, { key: `live-header-${index}` }))))));
};
//# sourceMappingURL=LiveTableHeader.js.map